// ----------------------------------------------------------------------------
// Convermax fitment-table integration
// ----------------------------------------------------------------------------
//
// Convermax injects the fitment table (and its show-more/less button) into the
// server-rendered `#cm-fitment-table` div, which sits inside the product
// <form>. Three quirks to handle theme-side:
//   1. Its buttons have no `type`, so inside the form they submit it (adds to
//      cart). Force `type="button"`.
//   2. The accordion locks to a fixed height when opened; the table resizing
//      afterward leaves rows clipped or a gap. Re-lock to match.
//   3. "Show less" shrinks the accordion and the button jumps off-screen. Pin
//      it in place while the table contracts.
//
// ----------------------------------------------------------------------------

var FITMENT_TABLE = '#cm-fitment-table';
var COLLAPSE_BUTTON = '.cm_fitment-table_collapse-button';
var ACCORDION_CONTENT = '.js-accordion__content';
var OPEN_CLASS = 'is-open';

// Force every Convermax-injected button to type="button" so it can't submit
// the surrounding product form.
function neutralizeSubmitButtons(table) {
  table.querySelectorAll('button:not([type="button"])').forEach(button => {
    button.type = 'button';
  });
}

// If the table sits inside an open accordion, re-measure and re-lock that
// accordion's height to match the table's current size.
function resyncAccordionHeight(table) {
  var content = table.closest("".concat(ACCORDION_CONTENT, ".").concat(OPEN_CLASS));
  if (!content) return;
  // Reset to auto first: scrollHeight never reports less than the locked
  // height, so it can't measure a shrunk table otherwise.
  content.style.height = 'auto';
  content.style.height = content.scrollHeight + 'px';
}
function initFitmentTable() {
  var table = document.querySelector(FITMENT_TABLE);
  if (!table) return;

  // Re-neutralise on each mutation: Convermax re-renders the table and its
  // buttons asynchronously.
  neutralizeSubmitButtons(table);
  new MutationObserver(() => neutralizeSubmitButtons(table)).observe(table, {
    childList: true,
    subtree: true
  });
  if (!('ResizeObserver' in window)) {
    resyncAccordionHeight(table);
    return;
  }

  // Remember where the button is on click, to pin it during the contraction.
  var anchorTop = null;
  var settleTimer = null;
  var prevHeight = table.offsetHeight;
  table.addEventListener('click', event => {
    var button = event.target.closest(COLLAPSE_BUTTON);
    if (button) anchorTop = button.getBoundingClientRect().top;
  });

  // Keep the accordion locked to the table's size, and hold the button in
  // place while it contracts.
  new ResizeObserver(entries => {
    var height = entries[0].contentRect.height;
    var shrinking = height < prevHeight - 0.5;
    prevHeight = height;
    resyncAccordionHeight(table);
    if (anchorTop !== null && shrinking) {
      var button = table.querySelector(COLLAPSE_BUTTON);
      if (button) window.scrollBy(0, button.getBoundingClientRect().top - anchorTop);

      // Release the anchor once the contraction settles.
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        anchorTop = null;
      }, 300);
    }
  }).observe(table);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFitmentTable);
} else {
  initFitmentTable();
}